import store from '../../store/configure-store';


/**
 * customizationParser
 * 
 * @param {string} login 
 * @returns 
 */
export const customizationParser = () => {
  const {login} = store.getState('login');
  const customization = login?.Customization;
  
  if (!customization) {
    return;
  }
  let parserdData;
  try {
    parserdData = JSON.parse(customization);
    return parserdData;
  } catch (error) {
    console.error("COULD NOT parse config");
    return null;
  }
};

export const isHideBonusRoundsEnabled = () => {
  const config = customizationParser();
  return config?.hideBonusRoundGameRules === true;
};

export const isShowAutoplayConfirmationEnabled = () => {
  const config = customizationParser();
  const rawValue =
    config?.showAutoplayConfirmation ?? config?.ShowAutoplayConfirmation;

  return (
    rawValue === true ||
    rawValue === 1 ||
    rawValue === "1" ||
    rawValue === "true"
  );
};

export const applyRushZoomLevel = () => {
  const config = customizationParser();
  const zoomLevel = config?.rushZoomLevel;

  if (zoomLevel == null || zoomLevel === '') {
    return;
  }

  const root = document.getElementById('root');
  if (root) {
    root.style.zoom = zoomLevel;
  }
};

export const getCurrencyNumberOfDigits = () => {
  const {login} = store.getState('login');

  return login?.CurrencyNumberOfDigits;
}